import TextMessageList from './TextMessageList';
import { TextMessageListProps, TextMessageListValueProps } from './types';

export type { TextMessageListProps, TextMessageListValueProps };
export default TextMessageList;
